import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type CartLinePriceFragment = { currency: string, discount: number, undiscount: number };

export const CartLinePriceFragmentDoc = gql`
    fragment CartLinePriceFragment on CartLinePriceType {
  currency
  discount
  undiscount
}
    `;